import { createSelector } from 'reselect';

export const getNewSubContractor = createSelector(
  (state) =>
    state.workOrders.scenes.creation.scenes.subContractorsUnionTrades.data
      .newSubContractor,
  (newSubContractor) => {
    return newSubContractor;
  }
);

export const getSubContractorAnswer = createSelector(
  (state) =>
    state.workOrders.scenes.creation.scenes.subContractorsUnionTrades.ui
      .subContractorAnswer,
  (subContractorAnswer) => {
    return subContractorAnswer;
  }
);

export const getSelectedSubContractorsId = createSelector(
  (state) =>
    state.workOrders.scenes.creation.scenes.subContractorsUnionTrades.data
      .selectedSubContractorsId,
  (selectedSubContractorsId) => {
    return selectedSubContractorsId;
  }
);

export const getShowNewContractor = createSelector(
  (state) =>
    state.workOrders.scenes.creation.scenes.subContractorsUnionTrades.ui
      .showNewContractor,
  (showNewContractor) => {
    return showNewContractor;
  }
);

export const getValidationError = createSelector(
  (state) =>
    state.workOrders.scenes.creation.scenes.subContractorsUnionTrades.ui
      .validationError,
  (validationError) => {
    return validationError;
  }
);

export const getSelectedUnionTradesId = createSelector(
  (state) =>
    state.workOrders.scenes.creation.scenes.subContractorsUnionTrades.data
      .selectedUnionTradesId,
  (selectedUnionTradesId) => {
    return selectedUnionTradesId;
  }
);

export const getDontKnowUnions = createSelector(
  (state) =>
    state.workOrders.scenes.creation.scenes.subContractorsUnionTrades.ui
      .dontKnowUnions,
  (dontKnowUnions) => {
    return dontKnowUnions;
  }
);

export const getNoUnions = createSelector(
  (state) =>
    state.workOrders.scenes.creation.scenes.subContractorsUnionTrades.ui
      .noUnions,
  (noUnions) => {
    return noUnions;
  }
);

export const getUnionTradesValidationError = createSelector(
  (state) =>
    state.workOrders.scenes.creation.scenes.subContractorsUnionTrades.ui
      .unionTradesValidationError,
  (unionTradesValidationError) => {
    return unionTradesValidationError;
  }
);



// WEBPACK FOOTER //
// ./src/selectors/admin/work-orders/creation/sub-contractors-union-trades.js